import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "sonner";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import StockDetail from "@/pages/StockDetail";
import Watchlist from "@/pages/Watchlist";
import Signals from "@/pages/Signals";
import Backtest from "@/pages/Backtest";
import Universe from "@/pages/Universe";
import Settings from "@/pages/Settings";
import Disclaimer from "@/pages/Disclaimer";
import Terms from "@/pages/Terms";
import Upgrade from "@/pages/Upgrade";
import PaymentSuccess from "@/pages/PaymentSuccess";

const TOAST_STYLE = {
  background: "#0f0f0f",
  border: "1px solid #222",
  borderRadius: 0,
  color: "#fff",
  fontFamily: "JetBrains Mono, monospace",
  fontSize: 12,
  letterSpacing: "0.04em",
};
const TOAST_OPTIONS = { style: TOAST_STYLE };

function Protected({ children }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === undefined) return <div className="min-h-screen bg-[#050505] text-white flex items-center justify-center font-mono-data text-xs text-[#555]">INIT…</div>;
  if (user === null) return <Navigate to="/login" state={{ from: loc }} replace />;
  return children;
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="bottom-right" theme="dark" toastOptions={TOAST_OPTIONS} />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/watchlist" element={<Protected><Watchlist /></Protected>} />
            <Route path="/signals" element={<Protected><Signals /></Protected>} />
            <Route path="/backtest" element={<Protected><Backtest /></Protected>} />
            <Route path="/universe" element={<Protected><Universe /></Protected>} />
            <Route path="/settings" element={<Protected><Settings /></Protected>} />
            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/upgrade" element={<Protected><Upgrade /></Protected>} />
            <Route path="/payment/success" element={<Protected><PaymentSuccess /></Protected>} />
            <Route path="/stock/:symbol" element={<Protected><StockDetail /></Protected>} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
